var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsterisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.25C12.4142 1.25 12.75 1.58579 12.75 2V10.1893L18.5407 4.3986C18.8336 4.10571 19.3085 4.10571 19.6014 4.3986C19.8943 4.69149 19.8943 5.16637 19.6014 5.45926L13.8107 11.25H22C22.4142 11.25 22.75 11.5858 22.75 12C22.75 12.4142 22.4142 12.75 22 12.75H13.8107L19.6014 18.5407C19.8943 18.8336 19.8943 19.3085 19.6014 19.6014C19.3085 19.8943 18.8336 19.8943 18.5407 19.6014L12.75 13.8107V22C12.75 22.4142 12.4142 22.75 12 22.75C11.5858 22.75 11.25 22.4142 11.25 22V13.8107L5.45926 19.6014C5.16637 19.8943 4.6915 19.8943 4.3986 19.6014C4.10571 19.3085 4.10571 18.8336 4.3986 18.5407L10.1893 12.75H2C1.58579 12.75 1.25 12.4142 1.25 12C1.25 11.5858 1.58579 11.25 2 11.25H10.1893L4.3986 5.45926C4.10571 5.16637 4.10571 4.6915 4.3986 4.3986C4.6915 4.10571 5.16637 4.10571 5.45926 4.3986L11.25 10.1893V2C11.25 1.58579 11.5858 1.25 12 1.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsterisk);
export default __webpack_public_path__ + "static/media/asterisk.b48860d43e532f0372bfccf4faa6a866.svg";
export { ForwardRef as ReactComponent };